module.exports = __webpack_public_path__ + "static/media/leaderboard.c86af804.svg";